/** Rental — English, the source of the other languages */
const rental = {
  "rental.title": "Rental",
  "rental.subtitle": "Stock, planning, events and purchasing",
  "rental.sections": "Rental sections",
  "rental.tab.planning": "Planning",
  "rental.tab.events": "Events",
  "rental.tab.customers": "Customers",
  "rental.tab.stock": "Stock",
  "rental.tab.suppliers": "Suppliers",
  "rental.tab.purchasing": "Purchasing",
  "rental.search": "Search",
  "rental.notes": "Notes",
  "rental.details": "Details",
  "rental.saveFailed": "Saving did not work",
  "rental.amountInvalid": "An amount is not a number, such as 12,50",
  "rental.percentInvalid": "A percentage is a number from 0 to 100",
  "rental.stock.sections": "Stock sections",
  "rental.stock.articles": "Articles",
  "rental.stock.items": "Inventory",
  "rental.stock.warehouses": "Warehouses",
  "rental.stock.transfers": "Transfers",
  "rental.stock.categories": "Categories",
  "rental.article.add": "Add article",
  "rental.article.edit": "Edit article",
  "rental.article.save": "Save article",
  "rental.article.saved": "Article saved",
  "rental.article.deleted": "Article deleted",
  "rental.article.deleteConfirm": "Delete the article {name}? An article with items, stock or lines cannot be deleted: deactivate it instead.",
  "rental.article.empty": "No articles yet",
  "rental.article.sku": "SKU",
  "rental.article.name": "Name",
  "rental.article.description": "Description",
  "rental.article.category": "Category",
  "rental.article.allCategories": "All categories",
  "rental.article.showInactive": "Show inactive",
  "rental.article.inactive": "Inactive",
  "rental.article.active": "Active (can be put on events)",
  "rental.article.perItem": "Per item (serial number)",
  "rental.article.bulk": "Quantity (bulk)",
  "rental.article.dayPrice": "Day price",
  "rental.article.weekendPrice": "Weekend price",
  "rental.article.weekPrice": "Week price",
  "rental.article.fromDayPrice": "Empty: from the day price",
  "rental.article.vatRate": "VAT (%)",
  "rental.article.vatDefault": "Empty: the company’s default rate",
  "rental.article.vatDefaultShort": "default",
  "rental.article.purchasePrice": "Purchase price",
  "rental.article.externalCode": "Code in the invoicing software",
  "rental.article.prices": "Prices excluding VAT",
  "rental.article.stock": "Stock",
  "rental.article.noStock": "None in stock",
  "rental.item.add": "Add item",
  "rental.item.save": "Save item",
  "rental.item.saved": "Item saved",
  "rental.item.empty": "No items",
  "rental.item.serial": "Serial number",
  "rental.item.mac": "MAC address",
  "rental.item.tag": "Tag",
  "rental.item.tagHint": "The NFC tag or QR code (optional for now)",
  "rental.item.article": "Article",
  "rental.item.warehouse": "Warehouse",
  "rental.item.status": "Status",
  "rental.item.statusOf": "Status of {name}",
  "rental.item.historyOf": "History of {name}",
  "rental.item.allArticles": "All articles",
  "rental.item.allWarehouses": "All warehouses",
  "rental.item.allStatuses": "Every status",
  "rental.bulk.title": "Quantity per warehouse",
  "rental.bulk.count": "Count",
  "rental.bulk.countOf": "Count {name}",
  "rental.bulk.counted": "Counted",
  "rental.bulk.note": "Why (optional)",
  "rental.bulk.save": "Save count",
  "rental.bulk.saved": "Count saved",
  "rental.bulk.quantity": "Quantity",
  "rental.bulk.packed": "Of which in cases",
  "rental.warehouse.add": "Add warehouse",
  "rental.warehouse.edit": "Edit warehouse",
  "rental.warehouse.editOf": "Edit {name}",
  "rental.warehouse.save": "Save warehouse",
  "rental.warehouse.saved": "Warehouse saved",
  "rental.warehouse.deleted": "Warehouse deleted",
  "rental.warehouse.deleteOf": "Delete {name}",
  "rental.warehouse.deleteConfirm": "Delete the warehouse {name}? Only an empty warehouse without events can be deleted.",
  "rental.warehouse.empty": "No warehouses yet: add the first one",
  "rental.warehouse.name": "Name",
  "rental.warehouse.address": "Address",
  "rental.warehouse.default": "Home warehouse",
  "rental.warehouse.makeDefault": "Make the home warehouse",
  "rental.warehouse.makeDefaultOf": "Make {name} the home warehouse",
  "rental.transfer.add": "New transfer",
  "rental.transfer.save": "Transfer",
  "rental.transfer.done": "Transferred",
  "rental.transfer.empty": "No transfers yet",
  "rental.transfer.from": "From",
  "rental.transfer.to": "To",
  "rental.transfer.when": "When",
  "rental.transfer.fromTo": "From → to",
  "rental.transfer.what": "What",
  "rental.transfer.by": "By",
  "rental.transfer.bulk": "Quantities",
  "rental.transfer.noItems": "No loose items or pieces in this warehouse (what is in a piece moves with its piece)",
  "rental.transfer.summary": "Items and pieces: {items} · bulk: {bulk}",
  "rental.category.add": "Add category",
  "rental.category.name": "Category name",
  "rental.category.saved": "Category saved",
  "rental.category.deleted": "Category deleted",
  "rental.category.renameOf": "Rename {name}",
  "rental.category.deleteOf": "Delete {name}",
  "rental.category.deleteConfirm": "Delete the category {name}? Its articles stay, without a category.",
  "rental.category.empty": "No categories yet",
  "rental.history.title": "History",
  "rental.history.empty": "Nothing has happened yet",
  "rental.history.quantity": { one: "{count} unit", other: "{count} units" },
  "rental.history.item.status": "Status changed",
  "rental.history.bulk.count": "Counted",
  "rental.history.transfer": "Transfer",
  "rental.history.receipt": "Received",
  "rental.history.subrental.return": "Returned to the supplier",
  "rental.status.IN_STOCK": "In stock",
  "rental.status.AT_EVENT": "At an event",
  "rental.status.IN_REPAIR": "In repair",
  "rental.status.LOST": "Lost",
  "rental.status.RETIRED": "Retired",
  "rental.status.RETURNED": "Returned to the supplier",
  "rental.status.REQUESTED": "Requested",
  "rental.status.RESERVED": "Reserved",
  "rental.status.CONFIRMED": "Confirmed",
  "rental.status.CLOSED": "Closed",
  "rental.status.CANCELLED": "Cancelled",
  "rental.status.DRAFT": "Draft",
  "rental.status.AWAITING_APPROVAL": "Awaiting approval",
  "rental.status.SENT": "Sent",
  "rental.status.PARTLY_RECEIVED": "Partly received",
  "rental.status.RECEIVED": "Received",
  "rental.customer.add": "Add customer",
  "rental.customer.edit": "Edit customer",
  "rental.customer.save": "Save customer",
  "rental.customer.saved": "Customer saved",
  "rental.customer.deleted": "Customer deleted",
  "rental.customer.deleteConfirm": "Delete the customer {name}? A customer with events cannot be deleted.",
  "rental.customer.empty": "No customers yet",
  "rental.customer.name": "Name",
  "rental.customer.contact": "Contact person",
  "rental.customer.email": "E-mail",
  "rental.customer.phone": "Phone",
  "rental.customer.address": "Address",
  "rental.customer.vatNumber": "VAT number",
  "rental.customer.externalRef": "Code in the invoicing software",
  "rental.customer.noEvents": "No events yet",
  "rental.supplier.add": "Add supplier",
  "rental.supplier.edit": "Edit supplier",
  "rental.supplier.save": "Save supplier",
  "rental.supplier.saved": "Supplier saved",
  "rental.supplier.deleted": "Supplier deleted",
  "rental.supplier.deleteConfirm": "Delete the supplier {name}? A supplier with orders cannot be deleted.",
  "rental.supplier.empty": "No suppliers yet",
  "rental.supplier.name": "Name",
  "rental.supplier.contact": "Contact person",
  "rental.supplier.email": "E-mail",
  "rental.supplier.phone": "Phone",
  "rental.supplier.address": "Address",
  "rental.supplier.vatNumber": "VAT number",
  "rental.supplier.language": "Language",
  "rental.supplier.languageHint": "Their order letters and mails are in this language",
  "rental.supplier.orders": "Orders and requests",
  "rental.supplier.noOrders": "No orders or requests yet",
  "rental.settings.prices": "Prices",
  "rental.settings.method": "How prices are worked out",
  "rental.settings.method.STAFFEL": "A day price with a staffel",
  "rental.settings.method.STAFFEL.hint": "The day price times the factor for the number of days",
  "rental.settings.method.FIXED": "Fixed day, weekend and week prices",
  "rental.settings.method.FIXED.hint": "Within one weekend (Friday 12:00 to Monday 12:00) the weekend price; else weeks and days, the days never more than a week",
  "rental.settings.staffel": "The staffel",
  "rental.settings.from": "From",
  "rental.settings.days": "Days",
  "rental.settings.daysTimes": "days:",
  "rental.settings.factor": "Factor",
  "rental.settings.dayPrice": "× the day price",
  "rental.settings.addRow": "Add a row",
  "rental.settings.removeRow": "Remove this row",
  "rental.settings.extraDay": "Each day after the last row adds (× the day price)",
  "rental.settings.staffelInvalid": "Each staffel row needs whole days and a factor such as 1,5",
  "rental.settings.vat": "Default VAT rate (%)",
  "rental.settings.currency": "Currency",
  "rental.settings.fourEyes": "Someone else must approve",
  "rental.settings.fourEyesHint": "Who makes or asks for a purchase order or sub-rental request cannot approve it",
  "rental.settings.letters": "On letters to suppliers",
  "rental.settings.lettersHint": "The company’s logo heads the letter when it has one",
  "rental.settings.letterName": "Legal name",
  "rental.settings.letterAddress": "Address",
  "rental.settings.letterVat": "VAT number",
  "rental.settings.letterCoc": "Chamber of Commerce number",
  "rental.settings.letterEmail": "E-mail",
  "rental.settings.letterPhone": "Phone",
  "rental.settings.save": "Save rental settings",
  "rental.settings.saved": "Rental settings saved",
  "rental.event.add": "New event",
  "rental.event.edit": "Edit event",
  "rental.event.save": "Save event",
  "rental.event.saved": "Event saved",
  "rental.event.empty": "No events yet",
  "rental.event.needed": "Choose the customer and the rental period",
  "rental.event.name": "Event",
  "rental.event.customer": "Customer",
  "rental.event.rentalStart": "Rental starts",
  "rental.event.rentalEnd": "Rental ends",
  "rental.event.rentalPeriod": "Rental period",
  "rental.event.materialPeriod": "Material out and back",
  "rental.event.materialOut": "Material out",
  "rental.event.materialBack": "Material back",
  "rental.event.materialApart": "Material goes out earlier or comes back later than the rental",
  "rental.event.warehouse": "Home warehouse",
  "rental.event.homeWarehouse": "The company’s home warehouse",
  "rental.event.site": "Site",
  "rental.event.externalRef": "Offer number",
  "rental.event.total": "Total",
  "rental.event.short": "Short",
  "rental.event.reserve": "Reserve",
  "rental.event.confirm": "Confirm",
  "rental.event.close": "Close",
  "rental.event.cancel": "Cancel event",
  "rental.event.reopen": "Reopen",
  "rental.event.cancelConfirm": "Cancel the event {name}? It then holds no material.",
  "rental.event.statusSaved": "Now: {status}",
  "rental.line.title": "Lines",
  "rental.line.empty": "No lines yet: add an article below",
  "rental.line.add": "Add line",
  "rental.line.save": "Save line",
  "rental.line.saved": "Line saved",
  "rental.line.deleted": "Line deleted",
  "rental.line.editOf": "Edit the line of {name}",
  "rental.line.deleteOf": "Delete the line of {name}",
  "rental.line.deleteConfirm": "Delete the line of {name}?",
  "rental.line.quantity": "Quantity",
  "rental.line.unitPrice": "Unit price",
  "rental.line.calculated": "calculated {price}",
  "rental.line.customPrice": "Own unit price",
  "rental.line.customHint": "Empty: the calculated {price}",
  "rental.line.availability": "Free and short",
  "rental.line.shortBy": "Short {count}",
  "rental.line.free": "Free: {free} (if the offers out fall through: {fall})",
  "rental.line.subrented": "{count} sub-rented",
  "rental.line.expected": "{count} expected",
  "rental.line.requested": "{count} requested, not yet confirmed",
  "rental.line.transferFrom": "Transfer from {name}",
  "rental.discount.title": "Discount",
  "rental.discount.type": "Kind",
  "rental.discount.none": "None",
  "rental.discount.percent": "A percentage",
  "rental.discount.amount": "An amount",
  "rental.discount.value": "Amount",
  "rental.discount.save": "Save discount",
  "rental.discount.saved": "Discount saved",
  "rental.totals.title": "Totals",
  "rental.totals.subtotal": "Subtotal",
  "rental.totals.discount": "Discount",
  "rental.totals.vat": "VAT {rate}",
  "rental.totals.total": "Total",
  "rental.planning.table": "Planning",
  "rental.planning.span": "Period",
  "rental.planning.day": "Day",
  "rental.planning.week": "Week",
  "rental.planning.month": "Month",
  "rental.planning.date": "Date",
  "rental.planning.previous": "Previous",
  "rental.planning.next": "Next",
  "rental.planning.today": "Today",
  "rental.planning.cell": "{article}, {day}: {free} free, {held} held",
  "rental.planning.cellShort": "— {count} short",
  "rental.planning.shortEvents": "Short events",
  "rental.planning.noneShort": "Nothing short in this period",
  "rental.planning.owned": "Owned",
  "rental.planning.subrented": "Sub-rented",
  "rental.planning.expected": "Expected",
  "rental.planning.from": "From",
  "rental.planning.held": "Held",
  "rental.planning.free": "Free",
  "rental.order.purchaseOrders": "Purchase orders",
  "rental.order.subRentals": "Sub-rentals",
  "rental.order.purchaseOrder": "Purchase order",
  "rental.order.subRental": "Sub-rental",
  "rental.order.newPurchase": "New purchase order",
  "rental.order.newSubRental": "New sub-rental",
  "rental.order.savePurchase": "Save purchase order",
  "rental.order.saveSubRental": "Save sub-rental",
  "rental.order.purchaseSaved": "Purchase order saved",
  "rental.order.subRentalSaved": "Sub-rental saved",
  "rental.order.edit": "Edit {number}",
  "rental.order.editShort": "Edit",
  "rental.order.deleted": "Deleted",
  "rental.order.deleteConfirm": "Delete the draft {number}?",
  "rental.order.empty": "Nothing here yet",
  "rental.order.number": "Number",
  "rental.order.supplier": "Supplier",
  "rental.order.warehouse": "Receiving warehouse",
  "rental.order.expected": "Expected delivery",
  "rental.order.window": "Rental period",
  "rental.order.from": "From",
  "rental.order.to": "Until",
  "rental.order.forEvent": "For the event",
  "rental.order.notes": "Notes for the supplier",
  "rental.order.supplierCode": "Supplier’s code",
  "rental.order.unitPrice": "Unit price",
  "rental.order.unitCost": "Cost per unit",
  "rental.order.received": "Received so far",
  "rental.order.items": "Registered items",
  "rental.order.madeBy": "Made by",
  "rental.order.askedBy": "Approval asked by",
  "rental.order.approvedBy": "Approved by",
  "rental.order.sentTo": "Sent to",
  "rental.order.askApproval": "Ask for approval",
  "rental.order.approve": "Approve",
  "rental.order.sendAgain": "Send again",
  "rental.order.recordConfirmation": "Record confirmation",
  "rental.order.registerItems": "Register items",
  "rental.order.saveItems": "Save items",
  "rental.order.itemsSaved": "Items registered",
  "rental.order.allRegistered": "All registered",
  "rental.order.close": "Close sub-rental",
  "rental.order.closeConfirm": "Close it? Its registered items go back to the supplier.",
  "rental.order.receive": "Receive",
  "rental.order.receiveLine": "{name}: received {received} of {quantity}, now",
  "rental.order.serialOf": "Serial number {n}",
  "rental.order.saveReceipt": "Save receipt",
  "rental.order.receiptSaved": "Receipt saved",
  "rental.order.newExpected": "New expected day",
  "rental.order.saveExpected": "Save day",
  "rental.order.expectedSaved": "Expected day saved",
  "rental.order.cancelOrder": "Cancel order",
  "rental.order.cancelRequest": "Cancel request",
  "rental.order.cancelConfirm": "Cancel {number}?",
  "rental.order.pdf": "Download PDF",
  "rental.order.waiting": "Waiting for someone who may approve",
  "rental.order.someoneElse": "Someone else must approve this",
  "rental.order.notSent": "Approved, not sent",
  "rental.order.notSentReason": "Approved, but the mail to the supplier did not go out: {reason}",
  "rental.order.done.request-approval": "Sent for approval",
  "rental.order.done.approve": "Approved and sent",
  "rental.order.done.send": "Sent to the supplier",
  "rental.order.done.cancel": "Cancelled",
  "rental.order.done.confirm": "Confirmation recorded",
  "rental.order.done.close": "Closed: its items went back",
  "rental.order.byHandHint": "Download the PDF and send it to the supplier yourself, then mark the order as sent.",
  "rental.order.markSent": "Mark as sent",
  "rental.order.markSentConfirm": "Mark {number} as sent? Do this once the supplier has the letter.",
  "rental.order.done.mark-sent": "Marked as sent",
  "rental.order.sentByHand": "By hand, marked by {name} · {when}",
  "rental.article.kind": "Kind",
  "rental.article.kit": "Kit",
  "rental.article.container": "Container",
  "rental.article.kindHint.ITEM": "Each one has its own serial number or tag",
  "rental.article.kindHint.BULK": "Counted, not one by one (cables, adapters)",
  "rental.article.kindHint.KIT": "Made of other articles when rented (its recipe); no stock of its own",
  "rental.article.kindHint.CONTAINER": "A case or set whose pieces each hold other articles (each piece has its own code)",
  "rental.kit.noStock": "A kit has no stock of its own: it is made of its parts when rented.",
  "rental.item.kind": "Kind",
  "rental.item.allKinds": "Items and pieces",
  "rental.item.kindPlain": "Items",
  "rental.item.kindPieces": "Pieces of containers",
  "rental.item.piece": "In piece",
  "rental.item.device": "Device",
  "rental.recipe.title": "Recipe",
  "rental.recipe.kitHint": "What one kit takes. An event line of N kits holds N times each part.",
  "rental.recipe.containerHint": "What each piece should hold. A piece that holds something else is shown as incomplete.",
  "rental.recipe.empty": "No parts yet",
  "rental.recipe.part": "Part",
  "rental.recipe.quantity": "Quantity",
  "rental.recipe.add": "Add part",
  "rental.recipe.removeOf": "Remove {name} from the recipe",
  "rental.recipe.saved": "Recipe saved",
  "rental.piece.title": "Pieces",
  "rental.piece.add": "Add piece",
  "rental.piece.edit": "Edit piece",
  "rental.piece.save": "Save piece",
  "rental.piece.saved": "Piece saved",
  "rental.piece.code": "Code",
  "rental.piece.contents": "Contents",
  "rental.piece.empty": "No pieces yet",
  "rental.piece.complete": "Complete",
  "rental.piece.incomplete": "Incomplete",
  "rental.piece.notRecipe": "Not what its recipe says:",
  "rental.piece.missing": "missing {count} × {name}",
  "rental.piece.extra": "extra {count} × {name}",
  "rental.piece.nothing": "Empty",
  "rental.piece.addItem": "Add an item",
  "rental.piece.addBulk": "Add bulk",
  "rental.piece.addDevice": "Add a device",
  "rental.piece.addOne": "Add",
  "rental.piece.item": "Item",
  "rental.piece.noItems": "No loose items in stock in this warehouse",
  "rental.piece.takeOut": "Take out",
  "rental.piece.takeOutOf": "Take {name} out",
  "rental.piece.contentsSaved": "Contents saved",
  "rental.device.search": "Serial number, MAC or name",
  "rental.device.searchHint": "Among the dashboard’s devices on the sites you may see",
  "rental.device.none": "No device found",
  "rental.device.pick": "Pick",
  "rental.device.pickOf": "Pick {name}",
  "rental.device.inInventory": "Already in the inventory",
  "rental.device.takenByOther": "Tied to another item",
  "rental.device.other": "Another device",
  "rental.device.article": "Article of its item",
  "rental.device.articleHint": "Not in the inventory yet: it becomes an item of this article",
  "rental.device.hidden": "On a site you cannot see",
  "rental.device.tie": "Tie to a device",
  "rental.device.tieOf": "Tie {name} to a device",
  "rental.device.tied": "Device tied",
  "rental.device.untie": "Untie the device",
  "rental.device.untieOf": "Untie the device of {name}",
  "rental.device.untieConfirm": "Untie the device of {name}? The item stays in the inventory.",
  "rental.device.untied": "Device untied",
  "rental.line.incomplete": { one: "{count} of the free pieces is incomplete", other: "{count} of the free pieces are incomplete" },
  "rental.line.perKit": "{count} per kit",
  "rental.planning.kitDay": "A kit has no stock of its own: these are the kits its parts allow at the lowest moment of the day.",
  "rental.order.expectedHint": "It counts as expected from the start of this day",
  "rental.recipe.quantityOf": "Quantity of {name}",
  "rental.item.kindItem": "Item",
  "rental.device.lastSeen": "Last seen {when}",
  "rental.history.item.piece.in": "Put in a piece",
  "rental.history.item.piece.out": "Taken out of a piece",
  "rental.history.bulk.piece": "Bulk in a piece",
  "rental.history.device.tie": "Tied to a device",
  "rental.history.device.untie": "Device untied",
  "rental.event.comment": "Comment",
  "rental.event.commentPlaceholder": "A note for everyone on this event: the client, the planners, the engineers",
  "rental.event.commentBy": "Last changed by {name}, {when}",
  "rental.event.saveComment": "Save comment",
  "rental.event.commentSaved": "Comment saved",
  "rental.load.title": "Loading",
  "rental.load.scan": "Scan or type a code",
  "rental.load.scanHint": "A tag, piece code, serial number or MAC: a scanner types it and presses Enter",
  "rental.load.mode": "What a scan does",
  "rental.load.modeLoad": "Load",
  "rental.load.modeReturn": "Return: {status}",
  "rental.load.loaded": "Loaded: {name}",
  "rental.load.returned": "Returned: {name}",
  "rental.load.failed": "Not loaded",
  "rental.load.returnFailed": "Not returned",
  "rental.load.count": "{out} of {quantity} out",
  "rental.load.byHand": "Add by hand",
  "rental.load.byHandOf": "Add by hand: {name}",
  "rental.load.empty": "Nothing loaded yet",
  "rental.load.out": "Out",
  "rental.load.when": "{when} · {who}",
  "rental.load.return": "Return",
  "rental.load.returnOf": "Return {name}",
  "rental.load.part": "Part of the kit",
  "rental.load.choose": "Item or piece",
  "rental.load.none": "Nothing of this is free in the event’s warehouse",
  "rental.load.quantity": "Quantity",
  "rental.load.load": "Load",
  "rental.load.missing": "Missing from the piece (lost)",
  "rental.load.cameBack": "Came back",
  "rental.load.cameBackHint": "Of {count} out; the rest is recorded lost",
  "rental.settings.archiveDays": "Keep an event site after its event closes (days)",
  "rental.settings.archiveDaysHint": "Archived, then removed after this many days (1–3650)",
  "rental.load.cameBackOf": "{back} of {out} came back",
  "rental.bulk.out": "Of which at events",
  "rental.bulk.countedHint": "What is in this warehouse now, in cases too; what is out at events is added to it",
  "rental.people.title": "Client people",
  "rental.people.hint": "People of this customer who sign in to see their events: the dates, the equipment on site and its state, and the comment",
  "rental.people.email": "E-mail address",
  "rental.people.name": "Name (optional)",
  "rental.people.only": "Only during the event",
  "rental.people.onlyHint": "Sign-in works only from material out to material back of one of their events",
  "rental.people.onlyFixed": "You have it yourself, so the people you invite have it too",
  "rental.people.main": "Main contact",
  "rental.people.mainHint": "May invite and remove others of this customer",
  "rental.people.invite": "Invite",
  "rental.people.invited": "Invitation sent to {email}",
  "rental.people.notSent": "{email} was added, but the mail could not be sent",
  "rental.people.none": "Nobody of this customer has an account yet",
  "rental.people.pending": "Invited — no password yet",
  "rental.people.invitedBy": "Invited by {name}, {when}",
  "rental.people.makeMain": "Make main contact",
  "rental.people.remove": "Remove",
  "rental.people.removeOf": "Remove {name}",
  "rental.people.removeConfirm": "Remove {name}'s access? They can no longer sign in to this customer's events.",
  "rental.people.removed": "Access removed",
  "rental.people.saved": "Saved",
  "rental.people.failed": "Not saved",
  "rental.portal.myEvents": "My events",
  "rental.portal.people": "People",
  "rental.portal.nav": "Client view",
  "rental.portal.elsewhere": "Switch",
  "rental.portal.noEvents": "No events to show yet",
  "rental.portal.noSite": "This event has no site any more",
  "rental.portal.viewAsClient": "View as client",
  "rental.portal.previewBar": "Viewing as {customer}'s client people — read-only",
  "rental.portal.previewBarNobody": "What {customer}'s client people will see once invited — read-only",
  "rental.portal.backToEvent": "Back to the event",
  "rental.portal.hiddenRequested": "The client does not see this event: it is requested",
  "rental.portal.hiddenCancelled": "The client does not see this event: it is cancelled",
  "rental.portal.account": "My account",
  "rental.category.nameNeeded": "Type a name for the category first",
  "rental.portal.devBanner": "This product is still in active development and is open for feedback",
  "rental.item.addHow": "How to add",
  "rental.item.fromDashboard": "From the dashboard",
  "rental.item.byHand": "By hand",
  "rental.item.brand": "Brand",
  "rental.item.allBrands": "All brands",
  "rental.item.browseQ": "Name, serial number or MAC",
  "rental.item.browseHint": "Part of it is enough, like RX",
  "rental.item.found": { one: "{count} device found", other: "{count} devices found" },
  "rental.item.tooMany": "The first {shown} of {total} shown: narrow the filter for the rest",
  "rental.item.selectAll": "Select all ({count})",
  "rental.item.selectNone": "Clear selection",
  "rental.item.addCount": { one: "Add {count} item", other: "Add {count} items" },
  "rental.item.addedMany": { one: "{count} item added", other: "{count} items added" },
  "rental.item.chooseDevices": "Tick the devices to add first",
  "rental.item.remove": "Remove",
  "rental.item.removeOf": "Remove {name}",
  "rental.item.removeConfirm": "Remove {name}? An item that never went out to an event is deleted; one that did is retired and keeps its history.",
  "rental.item.deleted": "Item deleted",
  "rental.item.retiredDone": "Item retired: its history is kept",
  "rental.item.showRetired": "Show retired",
  "rental.history.item.delete": "Item deleted",
  "rental.event.remove": "Remove event",
  "rental.event.removeConfirm": "Remove the event {name}? Its lines, what went out and came back, its site, the device comments and graphs are removed for good. Sub-rentals for it stay, without the event.",
  "rental.event.removed": "Event removed",
  "rental.event.removeFailed": "The event was not removed",
  "rental.event.removableFrom": "Can be removed from {date}",
  "rental.portal.push": "Push when my event's equipment goes offline",
  "rental.portal.pushNeedsApp": "Needs the Velanox app",
  "rental.portal.pushRefused": "Push was not allowed on this phone",
  "rental.scan.unsentConfirm": {"one": "1 scan has not been sent. Sign out anyway? It will be lost.", "other": "{count} scans have not been sent. Sign out anyway? They will be lost."},
  "rental.scan.summaryTitle": "Scans sent",
  "rental.scan.summary": "{loaded} loaded, {returned} returned, {refused} refused",
  "rental.scan.unknownCount": {"one": "1 code named nothing", "other": "{count} codes named nothing"},
  "rental.scan.dismiss": "Dismiss",
  "rental.scan.open": "Scan",
  "rental.scan.nfc": "NFC",
  "rental.scan.title": "Scanning for {name}",
  "rental.scan.torch": "Torch",
  "rental.scan.done": "Done",
  "rental.scan.sending": "Sending…",
  "rental.scan.waiting": "Waiting for the connection",
  "rental.scan.unknown": "names nothing",
  "rental.scan.loadedRow": "{name} · loaded",
  "rental.scan.returnedRow": "{name} · returned",
  "rental.scan.noCamera": "The camera is not allowed for the app: allow it in the phone's settings",
  "rental.scan.hint": "Hold codes in view",
  "rental.scan.hintNfc": "Hold codes in view, or a tag to the phone",
  "rental.scan.nfcPrompt": "Hold a tag to the top of the iPhone",
  "rental.tag.of": "Tag of {name}",
  "rental.tag.save": "Save tag",
  "rental.tag.hold": "Hold the tag to the phone",
  "rental.tag.writeFailed": "The tag could not be written: hold it still and try again",
  "rental.tag.scanTitle": "Scan a label",
  "rental.tag.scanHint": "Hold the label's code in view",
  "rental.tag.none": "No item has this tag",
  "rental.tag.looking": "Looking up the tag…",
  "rental.scan.sameItem": "same item, already counted",
  "rental.scan.unsentConfirmServer": {"one": "1 scan has not been sent. Choose another server anyway? It will be lost.", "other": "{count} scans have not been sent. Choose another server anyway? They will be lost."},
  "rental.people.clientExport": "Clients may export",
  "rental.people.clientExportHint": "The client people may download this event from their page: its devices with their notes, its graphs and the people list",
  "rental.people.exportOn": "Clients may export this event",
  "rental.people.exportOff": "Clients may no longer export this event",
  "rental.planning.exportNote": "free per day; a minus number is short by that many",
  "rental.portal.readOnly": "Read-only — what this equipment reports",
  "rental.portal.deviceGone": "This device is no longer on your event",
  "rental.portal.noStored": "Nothing has been stored for this device yet",
  "rental.portal.sinceLoaded": "From {when}, when it went out for this event",
  "rental.portal.unnamedLink": "Unnamed link",
  "rental.portal.range1h": "1 h",
  "rental.portal.range6h": "6 h",
  "rental.portal.cellular": "Cellular",
  "rental.portal.poe": "PoE",
  "rental.portal.standby": "Standby",
  "rental.portal.unnamedDevice": "Unnamed device",
  "rental.pings.title": "Pinged devices",
  "rental.pings.portalTitle": "Your devices",
  "rental.pings.intro": "Pinged by their IP address through the MikroTik radios on your event while it is on.",
  "rental.pings.companyIntro": "The customer's devices, pinged at their IP address through the MikroTik radios out on the customer's running event — only that event's network.",
  "rental.pings.name": "Name",
  "rental.pings.ip": "IP address",
  "rental.pings.state": "Status",
  "rental.pings.rtt": "Response time",
  "rental.pings.answered": "Last answered",
  "rental.pings.foundThrough": "Found through",
  "rental.pings.status.ONLINE": "Online",
  "rental.pings.status.OFFLINE": "Offline",
  "rental.pings.status.NO_ANSWER": "No answer",
  "rental.pings.status.UNKNOWN": "Not checked",
  "rental.pings.add": "Add device",
  "rental.pings.edit": "Edit",
  "rental.pings.save": "Save",
  "rental.pings.remove": "Remove",
  "rental.pings.removeConfirm": "Remove {name} from the pinged devices?",
  "rental.pings.pingNow": "Ping manually",
  "rental.pings.pingAll": "Ping all",
  "rental.pings.none": "No devices yet",
  "rental.pings.mode": "Ping checks",
  "rental.pings.mode.EVERY_30S": "Every 30 seconds",
  "rental.pings.mode.EVERY_MINUTE": "Every minute",
  "rental.pings.mode.EVERY_5_MINUTES": "Every 5 minutes",
  "rental.pings.mode.ON_OPEN": "Only when I open the dashboard",
  "rental.pings.mode.OFF": "Off",
  "rental.pings.changedBy": "Changed by {name}, {when}",
  "rental.pings.onOpenLine": "Checked only while this page is open (at most every 5 minutes)",
  "rental.pings.notOn": "Not checked now: none of the customer's events is on",
  "rental.pings.answering": "{count} of {total} answer",
  "rental.pings.failed": "That did not work",
  "rental.portal.pushPings": "Push when my devices stop answering",
  "rental.pings.notOnClient": "Not checked now: none of your events is on",
  "rental.pings.appliesNow": "Checked now as {mode}: the most frequent setting of your events that are on",
  "rental.event.openSite": "Open site",
}

export default rental
